import { useQuery } from '@tanstack/react-query'; // Import useQuery
import api from './axiosInterceptor';

const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL;

export default function FetchData(url, options = {}) { // No need for 'reload' prop anymore
    const tkn = sessionStorage.getItem("urtkn");

    const fetcher = async () => {
        const response = await api.get(`${baseUrl}/${url}`)
        return response.data;
    };

    const { data, error, isLoading, isFetching, refetch } = useQuery({
        queryKey: [url], // Unique key for the query, including dependencies
        queryFn: fetcher,
        enabled: options.enabled ?? true,
        refetchInterval: options.refetchInterval,
        refetchIntervalInBackground: options.refetchIntervalInBackground ?? false,
        // staleTime: 5 * 60 * 1000, // Optional: Data is considered fresh for 5 minutes
        // cacheTime: 10 * 60 * 1000, // Optional: Data stays in cache for 10 minutes
        // refetchOnWindowFocus: true, // Optional: Refetch when window regains focus
    });

    return {
        data,
        error,
        isLoading,
        isFetching,
        load: isLoading || isFetching,
        refetch,
    };
}